import React from "react";
import PropTypes from "prop-types";

const FilterChips = ({ filters }) => {
    if (!filters || filters.length === 0) return null;

    return (
        <div className="filter-chips">
            {filters.map((f, i) => (
                <span key={i} className="filter-chip">
                    {f.label ? `${f.label}: ${f.value}` : f.value}
                </span>
            ))}
        </div>
    );
};

FilterChips.propTypes = {
    filters: PropTypes.arrayOf(
        PropTypes.shape({
            label: PropTypes.string.isRequired,
            value: PropTypes.string.isRequired,
        })
    ),
};

export default FilterChips;
